import { signal } from '@angular/core';
import { debounce, FieldTree, max, min, required, SchemaPathTree } from '@angular/forms/signals';
import { BuriedDto } from '../../../../core/mceapi.client.generated';

export interface Buried {
  depth: number,
  soilThermalResistivity: number;
}

export function defaultBuried(defaultSoilThermalResistivity: number): Buried {
  return {
    depth: 0.9,
    soilThermalResistivity: defaultSoilThermalResistivity
  };
}

export function buildBuriedSchema(path: SchemaPathTree<Buried>) {

  required(path.depth, { message: `Depth is required` });
  min(path.depth, 0, { message: `Depth must be above 0 m` });
  max(path.depth, 3, { message: `Depth must be below 3 m` });
  debounce(path.depth, 500);

  required(path.soilThermalResistivity, { message: `Soil thermal resistivity is required` });
  min(path.soilThermalResistivity, 0, { message: `Soil thermal resistivity must be above 0 K.m/W` });
  max(path.soilThermalResistivity, 5, { message: `Soil thermal resistivity must be below 5 K.m/W` });
  debounce(path.soilThermalResistivity, 500);

}

export function createBuried(dto: BuriedDto) {
  const depth = dto.depth?.length;
  const soilThermalResistivity = dto.soilThermalResistivity?.thermalResistivity;

  if (depth === undefined || soilThermalResistivity === undefined) {
    throw new Error('Buried installation DTO is missing required values.');
  }

  return signal<Buried>({
    depth,
    soilThermalResistivity,
  });
}

export function createBuriedDto(model: FieldTree<Buried>) {
  return signal<BuriedDto>({
    depth: { length: model.depth().value() },
    soilThermalResistivity: { thermalResistivity: model.soilThermalResistivity().value() },
  });
}
